import { OktaAuthOptions } from '@okta/okta-auth-js';
import { autoinject } from 'aurelia-framework';
import { FrontendLogLevel } from '~/api/frontend-log-level';

import { GenericApi } from '~/api/generic-api';
import { FetchUtils } from '~/utils/fetch-utils';

export type Settings = Readonly<SettingsState>;

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.resources.SettingsResource.SettingsState
 */
interface SettingsState {
	user: Readonly<UserSettingsState> | null;
	version: Readonly<Version>;
	qasEnabled: boolean;
	useResAddrLine1And2: boolean;
	usePostAddrLine1And2: boolean;
	navBackgroundColor?: string;
	navLabel?: string;
	exportToCSVRowLimit?: number;
	oktaAuthOptions?: Readonly<OktaAuthOptions>;
	frontendLogLevel: Readonly<FrontendLogLevel>;
}

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.resources.Version
 */
export interface Version {
	versionNumber: string;
	buildDate: string;
	dbSchemaVersion: string;
	dbSchemaModified: string;
}

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.resources.SettingsResource.UserSettingsState
 */
interface UserSettingsState {
	canEditCustomisations: boolean;
	isTfnMatchAllowed: boolean;
	userGroup: string;
}

@autoinject
export class SettingsApi extends GenericApi {
	private static readonly Endpoint = 'api/settings';

	public getUser(): Promise<Settings> {
		return FetchUtils.getJSON<Settings>(SettingsApi.Endpoint + '/user');
	}

	public getGlobalSettings(): Promise<Settings> {
		return FetchUtils.getJSON<Settings>(SettingsApi.Endpoint + '/global');
	}
}
